import React from 'react'
import styled from 'styled-components'
import ChevronDown from 'react-feather/dist/icons/chevron-down'
import ChevronUp from 'react-feather/dist/icons/chevron-up'

import { color } from '../globalStyles'

const ShowMoreButton = styled.a`
  text-transform: uppercase;
  text-align: center;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem 0 0;
  bottom: 0;
  left: 0;
  color: inherit;
  margin: auto;
  position: relative;
  padding-left: 1em;

  &:before {
    content: '';
    width: 15rem;
    border-top: 1px solid ${color.midGrey};
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    display: ${props => (props.border ? 'block' : 'none')};
  }

  &.hidden {
    opacity: 0;
    pointer-events: none;
  }

  svg {
    height: 1em;
    width: 1em;
    margin-left: 0.5em;
  }
`

export default ({ open, handleOpen, className = '', border = true }) => (
  <ShowMoreButton
    onClick={handleOpen}
    href='#'
    border={border}
    className={`ShowMoreButton ${className}`}
  >
    {open ? (
      <React.Fragment>
        <span>Read Less</span>
        <ChevronUp />
      </React.Fragment>
    ) : (
      <React.Fragment>
        <span>Read More</span>
        <ChevronDown />
      </React.Fragment>
    )}
  </ShowMoreButton>
)



// WEBPACK FOOTER //
// ./src/components/ShowMoreButton.js